import { Checkbox } from '@arnold/common';
import * as React from 'react';
import { ClassicPreset } from 'rete';
import { Drag } from 'rete-react-plugin';

export class CheckboxControlData extends ClassicPreset.Control {
  constructor(
    public initialValue: boolean,
    public label: string,
    public change: (value: boolean) => void,
    public readOnly = false,
    public dataCy = 'checkbox-is-required-ariel',
    public dataIcom = 'checkbox-is-required-ariel',
  ) {
    super();
  }
  initialValueChangedIndicator?: number;
}

export const CheckboxControl = (props: { data: CheckboxControlData }) => {
  const [value, setValue] = React.useState(props.data.initialValue);
  const ref = React.useRef(null);

  Drag.useNoDrag(ref);

  React.useEffect(() => {
    setValue(props.data.initialValue);
  }, [props.data.initialValue, props.data.initialValueChangedIndicator]);

  return (
    <label className="checkboxAndLabel" ref={ref} data-icom={props.data.dataIcom} data-cy={props.data.dataCy}>
      <Checkbox
        selected={value}
        disabled={props.data.readOnly}
        onToggle={() => {
          setValue(!value);
          props.data.change(!value);
        }}
        text={<span className="checkboxLabel">{props.data.label} </span>}
      />
    </label>
  );
};
